import _ from 'lodash';
import { gsap } from 'gsap/all';
import autoBind from 'auto-bind';
import getSizeAtDepth from '../utils/getSizeAtDepth';

class InfiniteScrollGallery {
  constructor({
    camera, scrollableChildren, onCentredObject, bounds,
  }) {
    autoBind(this);

    this.bounds = bounds;
    this.scrollableChildren = scrollableChildren;
    this.selected = scrollableChildren[0];
    this.debounceScrollEnd = _.debounce(() => this.onScrollEnd(), 400);
    this.onCentredObject = onCentredObject;
    this.scrollDimensions = getSizeAtDepth(
      camera,
      scrollableChildren[0].position.z,
    );

    this.setInfiniteScrollPositions();

    onCentredObject(this.selected);

    this.addEventListeners();
  }

  onScrollEnd() {
    this.onCentredObject(this.selected);
    this.setInfiniteScrollPositions();

    const y = this.scrollDimensions[1];
    this.scrollableChildren.forEach((b, index) => {
      const screenPosition = index - 1 >= -1 ? index - 2 : this.scrollableChildren.length - index;
      gsap.to(b.position, { y: screenPosition * y * 0.75, duration: 0.8 });
    });
  }

  onTouchStart(event) {
    this.y = event.touches[0].clientY || event.clientY;
  }

  onTouchMove(event) {
    if (!this.y) return;

    const y = event instanceof TouchEvent ? event.touches[0].clientY : event.clientY;
    this.scrollGallery((this.y - y) * 0.02);
    this.y = y;
  }

  onTouchEnd() {
    this.y = undefined;
  }

  onMouseWheel({ deltaY }) {
    this.scrollGallery(deltaY * 0.01);
  }

  scrollGallery(direction) {
    this.scrollableChildren.forEach((child) => {
      child.position.y += direction;

      if (_.inRange(child.position.y, ...this.bounds) && this.selected !== child) {
        this.selected = child;
      }
    });

    this.setInfiniteScrollPositions();
    this.debounceScrollEnd();
  }

  setInfiniteScrollPositions() {
    if (this.scrollableChildren.indexOf(this.selected) + 2 >= this.scrollableChildren.length) {
      this.scrollableChildren[0].position.y = this.scrollableChildren[this.scrollableChildren.length - 1].position.y + this.scrollDimensions[1] * 0.75;
      this.scrollableChildren = [...this.scrollableChildren, this.scrollableChildren[0]];
      this.scrollableChildren.shift();
    } else if (this.scrollableChildren.indexOf(this.selected) <= 1) {
      this.scrollableChildren[this.scrollableChildren.length - 1].position.y = this.scrollableChildren[0].position.y - this.scrollDimensions[1] * 0.75;
      this.scrollableChildren = [this.scrollableChildren[this.scrollableChildren.length - 1], ...this.scrollableChildren];
      this.scrollableChildren.pop();
    }
  }

  addEventListeners() {
    window.addEventListener('wheel', this.onMouseWheel);
    window.addEventListener('touchstart', this.onTouchStart);
    window.addEventListener('touchmove', this.onTouchMove);
    window.addEventListener('touchend', this.onTouchEnd);
  }
}

export default InfiniteScrollGallery;
